import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Navbar.css';

const Navbar: React.FC = () => {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Check if this is a guardian or player login (but NOT a coach)
  const isGuardianOrPlayer = (user?.role === 'guardian' || user?.role === 'player') && !isAdmin;
  const isRecreational = user?.player?.playerType === 'Recreational';

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-brand">
          <img src="/logo.png" alt="Logo" className="nav-logo" />
          <span>STARS Academy</span>
        </Link>
        
        <div className="nav-links">
          {isGuardianOrPlayer ? (
            <>
              <Link to="/player/dashboard" className="nav-link">My Profile</Link>
              {!isRecreational && (
                <>
                  <Link to="/rankings" className="nav-link">Team Rankings</Link>
                  <Link to="/evaluations" className="nav-link">Team Evaluations</Link>
                </>
              )}
            </>
          ) : (
            <>
              <Link to="/" className="nav-link">Rankings</Link>
              <Link to="/teams" className="nav-link">Teams</Link>
              <Link to="/players" className="nav-link">Players</Link>
              <Link to="/evaluations" className="nav-link">Evaluations</Link>
              <Link to="/evaluation-history" className="nav-link">History</Link>
              
              {isAdmin && (
                <Link to="/admin" className="nav-link admin-link">Admin</Link>
              )}
            </>
          )}
          
          {user ? (
            <div className="user-menu">
              <span className="user-email">
                {(user.role === 'player' || user.role === 'guardian') && user.player
                  ? `${user.player.firstName} ${user.player.lastName}`
                  : user.email}
              </span>
              <button onClick={handleLogout} className="btn-logout">
                Logout
              </button>
            </div>
          ) : (
            <Link to="/login" className="btn-login">
              Login
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
